import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'

const state = {
  ideaCategories: null
}

// getters
const getters = {

}

// mutations
const mutations = {
  setIdeaCategories (currentState, categories) {
    currentState.ideaCategories = categories
  }
}

// actions
const actions = {
  loadIdeaCategories: function (context) {
    WordpressRestAPI.getViewContent('idea_chalenge_category?per_page=100')
      .then(response => {
        context.commit('setIdeaCategories', response.data)
        return Promise.resolve()
      })
      .catch(error => {
        console.error(error)
        return Promise.reject(new Error('Error loading categories'))
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/IdeaCategories.js